import axios from 'axios';

export function createContributorCTA(profileId, cta) {
  return axios.post(`/api/v1/lwadmin/profile/${profileId}/cta`, {
    authenticity_token: Livewire.formAuthenticityToken,
    cta,
  });
}

export function updateContributorCTA(profileId, cta) {
  return axios.put(`/api/v1/lwadmin/profile/${profileId}/cta/${cta.id}`, {
    authenticity_token: Livewire.formAuthenticityToken,
    cta,
  });
}
